import React from "react";

import { useDispatch, useSelector } from "react-redux";

import { patchConsignment } from "actions";

import { CarrierChargePicker } from "components/CarrierChargePicker";

import { getBusinesses, getCarrierChargesListSelector } from "selectors";

function attachCarrierNameToCharge(businessesByIdMap) {
  return function attachCarrierName(carrierCharge) {
    const carrierBusiness = businessesByIdMap[carrierCharge.carrier];
    if (carrierBusiness) {
      carrierCharge.carrierName = carrierBusiness.name;
    } else {
      carrierCharge.carrierName = "";
    }
    return carrierCharge;
  };
}

const ConnectedCarrierChargePicker = ({
  target,
  id,
  onAfterSelectCarrierCharge,
}) => {
  const dispatch = useDispatch();
  const businesses = useSelector(getBusinesses);
  const carrierCharges = (useSelector(getCarrierChargesListSelector) || []).map(
    attachCarrierNameToCharge(businesses),
  );

  function onSelectCarrierCharge(carrierChargeId) {
    if (target === "CONSIGNMENT") {
      dispatch(patchConsignment({ id, carrierChargeId }, id));
    } else {
      throw new Error("Target not yet supported");
    }
    onAfterSelectCarrierCharge();
  }

  return (
    <CarrierChargePicker
      carrierCharges={carrierCharges}
      onSelectCarrierCharge={onSelectCarrierCharge}
    />
  );
};

export default ConnectedCarrierChargePicker;
